// Preserve a transient trailing space so compound names (e.g. "VAN DAMME") stay typable while formatting live.
const keepTrailingSpace = (raw: string, formatted: string) => formatted + (/\s$/.test(raw) ? ' ' : '');

export const formatLastName = (raw: string) => keepTrailingSpace(raw, raw.trim().toUpperCase());

export const formatFirstName = (raw: string) => {
  const formatted = raw
    .trim()
    .toLowerCase()
    .replaceAll(/(^|[\s\-'])(\p{L})/gu, (_match, separator: string, char: string) => separator + char.toUpperCase());
  return keepTrailingSpace(raw, formatted);
};
